import { request } from "./HttpService";
import { ftAccessToken, ftRefreshToken } from "../constants/Constants";
import { refreshToken } from "./AuthService";
import { properties } from "../properties";

export function fetchReviewerQueue() {
    return request("GET", "/reviewer/queue");
}

export function fetchReviewDetails(peerReviewId) {
    return request("GET", `/reviewer/review/${peerReviewId}`);
}

export function respondToInvitation(peerReviewId, action, reason) {
    return request("POST", "/reviewer/respond", { peerReviewId, action, reason });
}

export function submitReviewFeedback(peerReviewId, feedback) {
    return request("POST", `/reviewer/feedback/${peerReviewId}`, feedback);
}

export function fetchReviewerStats() {
    return request("GET", "/reviewer/stats");
}

export function checkIsReviewer() {
    return request("GET", "/reviewer/is-reviewer");
}

export function downloadReviewManuscript(peerReviewId, firstCall) {
    return new Promise((resolve, reject) => {
        const accessToken = localStorage.getItem(ftAccessToken)?.replaceAll('"', '');
        let xhttp = new XMLHttpRequest();
        xhttp.open("GET", properties.host + "/reviewer/download/" + peerReviewId, true);
        xhttp.responseType = "blob";
        xhttp.setRequestHeader("Authorization", "Bearer " + accessToken);
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    resolve({ blob: xhttp.response, disposition: xhttp.getResponseHeader("Content-Disposition") });
                } else if (this.status === 403 && firstCall) {
                    refreshToken().then(newAccessToken => {
                        localStorage.setItem(ftAccessToken, JSON.stringify(newAccessToken));
                        downloadReviewManuscript(peerReviewId, false).then(resolve).catch(reject);
                    }).catch(() => {
                        localStorage.removeItem(ftAccessToken);
                        localStorage.removeItem(ftRefreshToken);
                        reject(new Error("Failed to refresh token."));
                    });
                } else {
                    reject(new Error("Download failed"));
                }
            }
        };
        xhttp.send();
    });
}
